<template>
  <div class="final">
    <img class="bg" src="./images/bg2.png" alt="" />
    <button class="btn" @click="openBeg()"></button>
    <div class="count">{{ lotteryNum }}</div>
    <div class="top-item top1" v-if="topList && topList[0]">
      <img
        :src="topList[0].avatarUrl"
        class="head-portrait"
        @click="toPlayerDetail(topList[0].userUuid)"
      />
      <img
        src="./images/top1.png"
        class="avatar-frame"
        @click="toPlayerDetail(topList[0].userUuid)"
      />
      <!-- <div class="user-name">{{ topList[0].nickname }}</div> -->
      <div class="score">獲得{{ topList[0].score }}積分</div>
      <button class="btn-item" @click="handleSendTicket(topList[0])"></button>
    </div>
    <div class="top-item top2" v-if="topList && topList[1]">
      <img
        :src="topList[1].avatarUrl"
        class="head-portrait"
        @click="toPlayerDetail(topList[1].userUuid)"
      />
      <img
        src="./images/top2.png"
        class="avatar-frame"
        @click="toPlayerDetail(topList[1].userUuid)"
      />
      <img src="./images/top2-tag.png" class="tag" />
      <div class="score">獲得{{ topList[1].score }}積分</div>
      <button class="btn-item" @click="handleSendTicket(topList[1])"></button>
    </div>
    <div class="top-item top3" v-if="topList && topList[2]">
      <img
        :src="topList[2].avatarUrl"
        class="head-portrait"
        @click="toPlayerDetail(topList[2].userUuid)"
      />
      <img
        src="./images/top3.png"
        class="avatar-frame"
        @click="toPlayerDetail(topList[2].userUuid)"
      />
      <img src="./images/top3-tag.png" class="tag" />
      <div class="score">獲得{{ topList[2].score }}積分</div>
      <button class="btn-item" @click="handleSendTicket(topList[2])"></button>
    </div>
    <div class="score-board-box" @scroll.stop>
      <div
        class="item"
        v-for="(item, index) of list.slice(3)"
        :key="item.userUuid"
      >
        <div class="left">
          <span class="index">{{ index + 4 }}</span>
          <img
            :src="item.avatarUrl"
            alt="頭像"
            class=""
            @click="toPlayerDetail(item.userUuid)"
          />
          <span class="user-name">{{ item.nickname }}</span>
        </div>
        <div class="right">
          <span class="score">{{ item.score }}</span>
          <img
            src="./images/btn.png"
            alt=""
            class=""
            @click="handleSendTicket(item)"
          />
        </div>
      </div>
    </div>

    <activity-dialog ref="activityDialog" @save="getDraw">
      <div class="final-dialog-box">
        <div class="input-box">
          選擇你要打開的福袋數量：
          <i class="el-icon-minus" @click="minusDrawCount"></i>
          <el-input v-model="drawCount"></el-input>
          <i class="el-icon-plus" @click="plusDrawCount"></i>
        </div>
        <div class="info2">需要消耗{{ drawCount * unitPrice }}幣</div>
      </div>
    </activity-dialog>
    <activity-dialog ref="ticketDialog" @save="sendTicket()">
      <div class="final-dialog-box ticket">
        <div class="input-box">
          確認
          <i class="el-icon-minus" @click="minusSendTicketCount"></i>
          <el-input v-model="sendTicketCount"></el-input>
          <i class="el-icon-plus" @click="plusSendTicketCount"></i>
          投應援票給<span class="user-name">
            {{ sendTicketUserName }}
          </span>
        </div>
        <div class="info2">(您當前持有{{ ticketCount }}個應援票)</div>
      </div>
    </activity-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ActivityDialog from './common-activity-dialog.vue';
import { Loading } from 'element-ui';

export default {
  name: 'Final',
  components: {
    ActivityDialog
  },
  props: {
    honorData: {
      type: Object,
      default: () => {}
    },
    userInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      drawCount: 10,
      unitPrice: 100,
      prizeList: [
        {
          code: 'P01',
          name: '666鑽石'
        },
        {
          code: 'P02',
          name: '888鑽石'
        },
        {
          code: 'P03',
          name: '1288鑽石'
        },
        {
          code: 'P07',
          name: '打call'
        },
        {
          code: 'P04',
          name: '66幣'
        },
        {
          code: 'P05',
          name: '88幣'
        },
        {
          code: 'P06',
          name: '128幣'
        },
        {
          code: 'P08',
          name: '應援票*5'
        }
      ],
      loading: false,
      isTest: false,
      timer: null,
      ticketTimer: null,
      ticketCount: 0,
      sendTicketCount: 10,
      sendTicketUserName: '',
      sendTicketUserId: '',
      loadingInstance: null
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['accountInfo']),
    isStart() {
      return new Date().getTime() > new Date(2025, 0, 25);
    },
    isEnd() {
      return new Date().getTime() > new Date(2025, 1, 20);
    },
    // 是否已登入狀態
    isLogined() {
      return this.uuid ? true : false;
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    lotteryNum() {
      return this.honorData ? this.honorData.lotteryNum || 0 : 0;
    },
    list() {
      return this.honorData ? this.honorData.NewYearStage3EndDate || [] : [];
    },
    balance() {
      return this.isTest
        ? 900
        : this.accountInfo
        ? this.accountInfo.balance
        : 0;
    },
    topList() {
      return this.list && this.list.length
        ? [this.list[0], this.list[1], this.list[2]]
        : [];
    }
  },
  methods: {
    async getTicketCount() {
      const { data } = await this.$http.get('/gift/list', {
        giftType: 'VOICE_ROOM'
      });
      if (data && data.length) {
        const item = data.find(item => item.id === 133);
        this.ticketCount = item && item.ownCount ? item.ownCount || 0 : 0;
      }
    },
    setLoading(message) {
      const text = message;
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: text,
        background: 'rgba(0, 0, 0, 0.7)',
        spinner: 'el-icon-loading',
        lock: true
      });
    },
    // 關閉loading狀態
    closeLoading() {
      this.loadingInstance.close();
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    // 檢查登入
    checkLogin() {
      return new Promise((resolve, reject) => {
        if (!this.isLogined) {
          this.$util.nativePie('LOGIN');
        } else {
          resolve();
        }
      });
    },
    openBeg() {
      if (!this.isStart) {
        this.showStart();
        return;
      }
      if (this.isEnd) {
        this.showEnd();
        return;
      }
      this.$refs.activityDialog.openDialog();
    },
    showEnd() {
      this.$confirm({
        content: '當前活動已結束，更多福利敬請留意nicee平臺，感謝您的支援呀～',
        title: '提示',
        showCancelButton: false,
        confirmButtonText: '確定',
        closeOnClickModal: false
      }).then(() => {
        // this.$router.push({ path: '/' });
      });
    },
    showStart() {
      this.$confirm({
        content: '活動尚未開始，敬請期待',
        title: '提示',
        showCancelButton: false,
        confirmButtonText: '確定',
        closeOnClickModal: false
      }).then(() => {});
    },
    async getDraw() {
      if (this.loading) {
        return;
      }
      if (!this.isTest) {
        await this.checkLogin();
      }
      if (this.balance >= this.drawCount * this.unitPrice) {
        this.getDrawResult();
      } else {
        this.$confirm({
          title: '餘額不足',
          content: `抽獎需消耗${this.drawCount * this.unitPrice}幣`,
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      }
      this.$refs.activityDialog.closeDialog();
    },
    // 獲取抽獎結果
    async getDrawResult() {
      this.loading = true;
      this.drawResult = [];
      this.setLoading('正在開啟');
      try {
        let data = '[]';
        await new Promise(resolve => setTimeout(resolve, 2000));
        if (this.isTest) {
          data =
            '[{"name":"P08","count":1},{"name":"P07","count":3},{"name":"P06","count":1}]';
          // data = '[{"name":"P01","count":1}]';
        } else {
          const result = await this.$http.get('/activity/lottery', {
            dictType: 'lotteryConf',
            count: this.drawCount
          });
          data = result.data;
        }
        if (data) {
          this.drawResult = JSON.parse(data) || [];
          // this.lotteryNum = this.lotteryNum + this.drawCount;
          if (!this.isTest) {
            this.$store.dispatch('app/getUserAccount');
          }
          this.$emit('getActivityData');
          this.endDraw();
        }
      } catch (error) {
        this.errorResponse = error;
        this.$message('抽福袋失敗');
      } finally {
        this.closeLoading();
        this.loading = false;
      }
    },
    endDraw() {
      let drawName = '';
      if (
        this.drawResult.length === 0 ||
        (this.drawResult.length === 1 &&
          this.drawResult[0].name === this.emptyCode)
      ) {
        this.$confirm({
          content: `祝你好運`,
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          dangerouslyUseHTMLString: true
        });
      } else {
        this.drawResult.forEach(item => {
          const prize = this.prizeList.find(prize => {
            return prize.code == item.name;
          });
          if (prize) {
            if (prize.code !== this.emptyCode) {
              drawName = `${drawName}${prize.name}*${1 * item.count}\n`;
            }
          }
        });
        drawName = drawName.slice(0, -1);
        this.$confirm({
          content: `
          ${drawName}
          `,
          title: '恭喜你抽中了',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          dangerouslyUseHTMLString: true
        });
      }
    },
    plusDrawCount() {
      this.drawCount += 5;
    },
    minusDrawCount() {
      this.drawCount -= 1;
    },
    plusSendTicketCount() {
      this.sendTicketCount += 5;
    },
    minusSendTicketCount() {
      this.sendTicketCount -= 1;
    },
    handleSendTicket(item) {
      if (!this.isStart) {
        this.showStart();
        return;
      }
      if (this.isEnd) {
        this.showEnd();
        return;
      }
      this.sendTicketUserId = item.userUuid;
      this.sendTicketUserName = item.nickname;
      this.$refs.ticketDialog.openDialog();
    },
    async sendTicket() {
      if (this.loading) {
        return;
      }
      if (!this.isTest) {
        await this.checkLogin();
      }
      if (this.ticketCount >= this.sendTicketCount && this.sendTicketCount) {
        this.sendTicketRequest();
      } else {
        this.$confirm({
          title: '應援票不足',
          content: `當前有${this.ticketCount}張應援票`,
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      }
      this.$refs.ticketDialog.closeDialog();
    },
    async sendTicketRequest() {
      this.loading = true;
      this.setLoading();
      try {
        await this.$http.post('gift/send', {
          playerUserUuid: this.sendTicketUserId,
          count: this.sendTicketCount,
          giftId: 133
        });
        this.getTicketCount();
        this.$emit('getActivityData');
        this.$message.success('投票成功');
      } catch (error) {
        this.$message('投票失敗');
      } finally {
        this.loading = false;
        this.closeLoading();
      }
    }
  },
  created() {
    this.getTicketCount();
  }
};
</script>
<style lang="scss" scoped>
.final {
  width: 100%;
  //   height: dPx(1995);
  position: relative;
  font-size: dPx(12);
  > .bg {
    width: 100%;
    max-width: 100%;
  }
  .btn {
    position: absolute;
    top: 1239px;
    width: 173px;
    height: 66px;
    left: 32px;
  }
  .count {
    font-size: 32px;
    position: absolute;
    top: 1510px;
    color: #fefb7a;
    text-shadow: 1px -1px 0 #5b1300, 1px -1px 0 #5b1300, -1px 1px 0 #5b1300,
      1px 1px 0 #5b1300; /*no*/
    // text-shadow: 1px 1px 1px #5b1300; /*no*/
    left: 420px;
  }

  .top-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 28px;
    flex: none;
    color: white;
    position: absolute;
    top: 2861px;
    .btn-item {
      width: 260px;
      height: 57px;
      margin-top: 27px;
    }
    .head-portrait {
      border-radius: 50%;
      object-fit: cover;
      width: 148px;
      height: 148px;
      position: absolute;
      top: 68px;
      left: 73px;
      z-index: 1;
    }
    .avatar-frame {
      width: 294px;
      height: auto;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }
    .score {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
      text-align: center;
    }
    .score {
      margin-top: 373px;
      font-size: 28px;
    }
    &.top1 {
      left: 231px;
      width: 294px;
    }
    &.top2,
    &.top3 {
      width: 192px;
      .head-portrait {
        width: 108px;
        height: 108px;
        top: 45px;
        left: 45px;
      }
      .avatar-frame {
        width: 192px;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
      }
      .tag {
        width: 63px;
        height: auto;
        position: absolute;
        top: 148px;
        left: 64px;
        z-index: 2;
      }
      .score {
        margin-top: 191px;
        font-size: 18px;
      }
    }
    &.top2 {
      top: 3517px;
      right: 75px;
    }
    &.top3 {
      top: 3515px;
      left: 84px;
      .head-portrait {
        width: 108px;
        height: 108px;
        top: 47px;
        left: 36px;
      }
      .avatar-frame {
        width: 172px;
      }
      .tag {
        left: 55px;
      }
      .btn-item {
        margin-top: 24px;
      }
      .score {
        margin-top: 194px;
      }
    }
  }

  .score-board-box {
    position: absolute;
    top: 3957px;
    left: 50%;
    transform: translateX(-50%);
    width: 700px;
    height: 1300px;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 20px;
      width: 100%;
      height: 150px;
      font-size: 28px;
      margin-bottom: 17px;
      background: url('./images/item-bg.png') no-repeat;
      background-size: 100% auto;
      color: white;
      .left,
      .right {
        display: flex;
        align-items: center;
      }
      .right {
        margin-left: 30px;
      }
      .left {
        .index {
          margin-left: 48px;
          margin-right: dPx(20);
          width: 30px;
          text-align: right;
        }
        img {
          width: 72px;
          height: 72px;
          border-radius: 50%;
          margin-right: dPx(26);
          object-fit: cover;
          border: 2px solid black;
        }
        .user-name {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 174px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        img {
          width: dPx(58);
          height: auto;
          margin: 0 0 0 14px;
        }
      }
    }
  }
}
.final-dialog-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: dPx(18);
  color: white;
  position: absolute;
  top: 70px;
  left: 0;
  line-height: 1.5;
  .user-name {
    display: inline-block;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: none;
  }
  .info2 {
    font-size: dPx(14);
    margin-top: dPx(18);
  }
  .input-box {
    display: flex;
    align-items: center;
    /deep/ .el-input__inner {
      background: none;
      border: none;
      font-size: 38px;
      text-align: center;
      color: white;
    }
    /deep/ .el-input {
      width: 80px;
      text-align: center;
    }
  }
}
</style>
